module.exports = __webpack_public_path__ + "img/fr_get.334174a.png";